var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-progress-overlay',{attrs:{"opacity":1,"color":"white","background-color":"transparent","pending":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }